import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetComponentSettingsOptions,
  GetComponentSettingsResponse,
  GetGlobalSettingsOptions,
  GetGlobalSettingsResponse,
  SetComponentSettingsOptions,
  SetComponentSettingsResponse,
  SetGlobalSettingsOptions,
  SetGlobalSettingsResponse,
  getComponentSettings as universalGetComponentSettings,
  getGlobalSettings as universalGetGlobalSettings,
  setComponentSettings as universalSetComponentSettings,
  setGlobalSettings as universalSetGlobalSettings,
} from './app-settings-v1-settings-app-settings.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/app-settings' };

export function setComponentSettings(
  httpClient: HttpClient
): SetComponentSettingsSignature {
  return (componentId: string, options?: SetComponentSettingsOptions) =>
    universalSetComponentSettings(
      componentId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface SetComponentSettingsSignature {
  /**
   * Set component settings by componentId
   * @param - The component Id
   */
  (componentId: string, options?: SetComponentSettingsOptions): Promise<
    NonNullablePaths<
      SetComponentSettingsResponse,
      | `host`
      | `translations`
      | `translations.${number}.languageKey.languageCode`
      | `translations.${number}.languageKey.regionCode`
      | `translations.${number}.languageKey.scriptVariant`
      | `states`,
      5
    >
  >;
}

export function getComponentSettings(
  httpClient: HttpClient
): GetComponentSettingsSignature {
  return (componentId: string, options?: GetComponentSettingsOptions) =>
    universalGetComponentSettings(
      componentId,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetComponentSettingsSignature {
  /**
   * Get component settings by componentId
   * @param - The component we want data for. Component ids can be from the site or oneApp
   */
  (componentId: string, options?: GetComponentSettingsOptions): Promise<
    NonNullablePaths<
      GetComponentSettingsResponse,
      `state` | `host` | `globalSettings.state` | `globalSettings.host`,
      3
    >
  >;
}

export function setGlobalSettings(
  httpClient: HttpClient
): SetGlobalSettingsSignature {
  return (options?: SetGlobalSettingsOptions) =>
    universalSetGlobalSettings(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface SetGlobalSettingsSignature {
  /**
   * Set global settings by instanceId (extracted from Authorization)
   */
  (options?: SetGlobalSettingsOptions): Promise<
    NonNullablePaths<
      SetGlobalSettingsResponse,
      | `componentSettings`
      | `componentSettings.${number}.state`
      | `componentSettings.${number}.host`
      | `host`
      | `translations`
      | `translations.${number}.languageKey.languageCode`
      | `translations.${number}.languageKey.regionCode`
      | `translations.${number}.languageKey.scriptVariant`
      | `states`,
      5
    >
  >;
}

export function getGlobalSettings(
  httpClient: HttpClient
): GetGlobalSettingsSignature {
  return (options?: GetGlobalSettingsOptions) =>
    universalGetGlobalSettings(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetGlobalSettingsSignature {
  /**
   * Get global settings by instanceId (extracted from Authorization)
   */
  (options?: GetGlobalSettingsOptions): Promise<
    NonNullablePaths<
      GetGlobalSettingsResponse,
      | `state`
      | `host`
      | `componentSettings`
      | `componentSettings.${number}.state`
      | `componentSettings.${number}.host`,
      4
    >
  >;
}

export {
  AppSettings,
  BulkGetComponentSettingsRequest,
  BulkGetComponentSettingsResponse,
  ComponentSettings,
  GetComponentSettingsItem,
  GetComponentSettingsOptions,
  GetComponentSettingsRequest,
  GetComponentSettingsResponse,
  GetGlobalSettingsForMigrationRequest,
  GetGlobalSettingsForMigrationResponse,
  GetGlobalSettingsOptions,
  GetGlobalSettingsRequest,
  GetGlobalSettingsResponse,
  GetRequest,
  GetResponse,
  Host,
  LanguageKey,
  Scope,
  SetComponentSettingsForMigrationRequest,
  SetComponentSettingsForMigrationResponse,
  SetComponentSettingsItem,
  SetComponentSettingsOptions,
  SetComponentSettingsRequest,
  SetComponentSettingsResponse,
  SetGlobalSettingsForMigrationRequest,
  SetGlobalSettingsForMigrationResponse,
  SetGlobalSettingsOptions,
  SetGlobalSettingsRequest,
  SetGlobalSettingsResponse,
  SetRequest,
  SetResponse,
  State,
  TranslatedLanguage,
  UpdateRequest,
  UpdateResponse,
} from './app-settings-v1-settings-app-settings.universal.js';
